module.exports = __webpack_public_path__ + "img/tu3.46b62d44.jpg";